import React from "react";
import "./section.css";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { toggleItem } from "../../../store/slices/pvc_checklsit.slices";
import { PV_CHECKLIST_STATIC } from "../../data/pvc_data";

export default function PVCCheckList() {
  const checklistValues = useSelector((state) => state.pvc_list);

  const dispatch = useDispatch();

  const handleStatusClick = (key) => {
    dispatch(toggleItem(key));
  };

  const renderStatus = (checked) => {
    if (checked === true) return <span>✓</span>;
    if (checked === false) return <span>N/A</span>;
    return <span>—</span>;
  };

  return (
    <Box className="pvCheckList">
      {PV_CHECKLIST_STATIC.map((section) => (
        <Box key={section.title} className="table-container">
          <Typography variant="h5" className="section-title">
            {section.title}
          </Typography>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Item</TableCell>
                  <TableCell colSpan={2}>Requirement</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Label</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {section.subsections.map((sub) => (
                  <React.Fragment key={sub.subtitle}>
                    {sub.items.map((item, itemIndex) => (
                      <TableRow key={item.key}>
                        {/* Subsection Title (RowSpan) */}
                        {itemIndex === 0 && (
                          <TableCell
                            rowSpan={sub.items.length}
                            className="subsection-cell"
                          >
                            {sub.subtitle}
                          </TableCell>
                        )}

                        {/* Label */}
                        <TableCell className="requirement-label">
                          {item.label}
                        </TableCell>

                        {/* Status */}
                        <TableCell
                          className="status-select"
                          onClick={() => handleStatusClick(item.key)}
                          style={{
                            cursor: "pointer",
                            fontWeight: 600,
                            color: "gray",
                          }}
                        >
                          {renderStatus(checklistValues[item.key])}
                        </TableCell>
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Box>
  );
}
